import { IComponentOptions } from 'angular';
import { StudentCreditGapsPanelProgressCtrl } from './student-credit-gaps-panel-progress.controller';

export const StudentCreditGapsPanelProgressComponent: IComponentOptions = {
  bindings: {
    school: '<',
    student: '<',
    sharedState: '<',
  },
  controller: StudentCreditGapsPanelProgressCtrl,
  template: require('./student-credit-gaps-panel-progress.html'),
};
